import { clx } from "@modules/common/components/ui"

type AmzPriceProps = {
  amount: number
  currencyCode: string
  size?: "sm" | "md" | "lg"
  className?: string
}

// Price set in the display face with tabular figures: "129,00 EUR" style,
// the currency symbol reduced to a technical suffix.
const AmzPrice = ({ amount, currencyCode, size = "md", className }: AmzPriceProps) => {
  const parts = new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: currencyCode.toUpperCase(),
  }).formatToParts(amount)

  const number = parts
    .filter((p) => p.type !== "currency" && p.type !== "literal")
    .map((p) => p.value)
    .join("")
  const symbol = parts.find((p) => p.type === "currency")?.value ?? ""

  const big = {
    sm: "text-base",
    md: "text-2xl tracking-[-0.02em]",
    lg: "text-[28px] small:text-[36px] tracking-[-0.03em]",
  }[size]

  return (
    <span className={clx("inline-flex items-baseline gap-x-1 leading-none text-zl-ink", className)}>
      <span className={clx(big, "font-display font-medium tabular-nums")}>{number}</span>
      <span className={clx("font-mono", size === "sm" ? "text-xs" : "text-sm")}>{symbol}</span>
    </span>
  )
}

export default AmzPrice
